import { useQuery } from '@tanstack/react-query';
import {
  collateralMonitoringApi,
  type CollateralMonitoringSummary,
} from '../api/services/collateral-monitoring';

export function useCollateralMonitoringSummary() {
  return useQuery<CollateralMonitoringSummary>({
    queryKey: ['admin', 'collateral-monitoring', 'summary'],
    queryFn: () => collateralMonitoringApi.getSummary(),
  });
}

export function useCollateralValueTrend(hours?: number) {
  return useQuery({
    queryKey: ['admin', 'collateral-monitoring', 'value-trend', hours],
    queryFn: () => collateralMonitoringApi.getValueTrend(hours),
  });
}

export function useCollateralDistribution() {
  return useQuery({
    queryKey: ['admin', 'collateral-monitoring', 'distribution'],
    queryFn: () => collateralMonitoringApi.getDistribution(),
  });
}

export function useCollateralDeficiencies() {
  return useQuery({
    queryKey: ['admin', 'collateral-monitoring', 'deficiencies'],
    queryFn: () => collateralMonitoringApi.getDeficiencies(),
  });
}
